window.$ = window.jQuery = require('jquery');
// put focus on search input
$('#site-search-collapse').on('shown.bs.collapse', function () {
	$("#site-search #query").focus();
});


// put focus on first link
	$('#quick-links-collapse').on('shown.bs.collapse', function () {
		 $('#quick-links-collapse a:eq(0)').focus();
});



// hide site-search on blur
$('#site-search-collapse').on('shown.bs.collapse', function () {

	$(document).click(function(event) { 
		if(!$(event.target).closest('#site-search').length) {
			if($('#site-search-collapse').hasClass("in")) {
				$('#site-search-collapse').collapse("hide");
			}
		}        
	});
});

// hide quick-links on blur
$('#quick-links-collapse').on('shown.bs.collapse', function () {
	$(document).click(function(event) { 
		if(!$(event.target).closest('#quick-links').length) {
			if($('#quick-links-collapse').hasClass("in")) {
				$('#quick-links-collapse').collapse("hide");
			}
		}        
	});
});

// global map
$('.dropdown-menu #carousel-global-map').click(function(event){  
	event.stopImmediatePropagation();
});
$('#map-section .carousel-indicators li a').on('click', function(e) {	
	$('#carousel-global-map').carousel($('.carousel-indicators li a').index(this));
	$('.carousel-indicators li a i').removeClass( "pulse" )
	$(this).find('i').addClass( "pulse" )	  
});

// footer map
$('#streatham-campus').mouseenter(function() {
   $('#streatham-marker').animate({fontSize: "35px", top: "-=10px", left: "-=4px"}, 'fast');
   $('#streatham-campus').css("background", "#009cb5")
   $('#streatham-marker').css('zIndex', '9999999');
});
$('#streatham-campus').mouseleave(function(){   
	  $('#streatham-marker').animate({fontSize: "25px", top: "+=10px", left: "+=4px"}, 'fast');
	  $('#streatham-campus').css("background", "none")
	  $('#streatham-marker').css('zIndex', '9999998');
});
$('#stlukes-campus').mouseenter(function() {
   $('#stlukes-marker').animate({fontSize: "35px",  top: "-=10px", left: "-=4px"}, 'fast');
   $('#stlukes-campus').css("background", "#89b03b")
   $('#stlukes-marker').css('zIndex', '9999999');
});
$('#stlukes-campus').mouseleave(function(){   
	  $('#stlukes-marker').animate({fontSize: "25px", top: "+=10px", left: "+=4px"}, 'fast');
	   $('#stlukes-campus').css("background", "none")
	   $('#stlukes-marker').css('zIndex', '9999998');
});
$('#penryn-campus').mouseenter(function() {
   $('#penryn-marker').animate({fontSize: "35px", top: "-=10px", left: "-=4px"}, 'fast');
   $('#penryn-campus').css("background", "#e7881c")
	$('#penryn-marker').css('zIndex', '9999999');
});
$('#penryn-campus').mouseleave(function(){   
	  $('#penryn-marker').animate({fontSize: "25px", top: "+=10px", left: "+=4px"}, 'fast');
	   $('#penryn-campus').css("background", "none")
	$('#penryn-marker').css('zIndex', '9999998');
});
$('#truro-campus').mouseenter(function() {
   $('#truro-marker').animate({fontSize: "35px", top: "-=10px", left: "-=4px"}, 'fast');
   $('#truro-campus').css("background", "#3a9187")
	$('#truro-marker').css('zIndex', '9999999');
});
$('#truro-campus').mouseleave(function(){   
	  $('#truro-marker').animate({fontSize: "25px", top: "+=10px", left: "+=4px"}, 'fast');
	   $('#truro-campus').css("background", "none")
	$('#truro-marker').css('zIndex', '9999998');
});

// make menu work on handhelds	
if(window.matchMedia("(max-width: 992px)").matches){
	$( "#header-navbar" ).removeAttr( "data-hover" )
}
